import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { listingsFilterCall } from '../../../actions/listings'
import { triggerListingsFilterCall } from '@mfs/client/listings-client/helpers/filters/listingsFilterCallStream'

export const useDebouncedListingsFilterCall = () => {
  const dispatch = useDispatch()
  const isDebounceListingsFilterCall = useSelector(
    (state) => state.pclnBootstrapData?.isDebounceListingsFilterCall
  )

  const debouncedListingsFilterCall = useCallback(
    (...args) => {
      if (isDebounceListingsFilterCall) {
        triggerListingsFilterCall(args)
      } else {
        dispatch(listingsFilterCall(...args))
      }
    },
    [dispatch, isDebounceListingsFilterCall]
  )

  return {
    debouncedListingsFilterCall,
  }
}
